import { SET_ROUTE_LOCATION } from "./types";



export const setRouteLocation = route => async dispatch => {
  dispatch({
    type: SET_ROUTE_LOCATION,
    payload: route
  });
};




